import { render, staticRenderFns } from "./HKVideo.vue?vue&type=template&id=ff49a0ca&scoped=true"
import script from "./HKVideo.vue?vue&type=script&lang=js"
export * from "./HKVideo.vue?vue&type=script&lang=js"
import style0 from "./HKVideo.vue?vue&type=style&index=0&id=ff49a0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff49a0ca",
  null
  
)

export default component.exports